import {pushDataLayerEvent} from './pushDataLayerEvent';

type VirtualPageViewPayload = {
  pageLocation: string;
  pagePath: string;
};

export function pushVirtualPageView(
  payload: VirtualPageViewPayload,
): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      pushDataLayerEvent('virtual_pageview', {
        page_location: payload.pageLocation,
        page_path: payload.pagePath,
        page_title: document.title,
      });
    });
  });
}
